class PrivacyModal extends ModalDialog {
  constructor() {
    super();
    document.addEventListener('DOMContentLoaded', () => {
      this.newsletter_popup_days = parseInt(Shopify.theme_settings.newsletter_popup_days);
      this.cookie_enabled = this.newsletter_popup_days != 0 ? true : false;
      let newsletter_popup_seconds = parseInt(Shopify.theme_settings.newsletter_popup_seconds);
      if (Shopify.theme_settings.newsletter_popup) {
        setTimeout(() => {
          this.privacyModal();
        }, 10000);
      }
    });
  }

  customHide() {
    localStorage.setItem('startDate', JSON.stringify(Date.now()));
    this.style.display = 'none';
    document.body.classList.remove('body-overflow');
  }

  isStorageTimeExpired(key) {
    const startingOfTime = this.newsletter_popup_days * 24 * 60 * 60 * 1000; // 24 hour
    const endOfTime = parseInt(localStorage.getItem(key)) + startingOfTime;
    const nowDate = Date.now();

    if (nowDate < endOfTime) {
      return false;
    } else {
      return true;
    }
  }

  privacyModal() {
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('confirm-btn')) {
        this.customHide();
      } else if (e.target.classList.contains('modal-close') || e.target.classList.contains('reject-approval')) {
        window.location.href = '/policies/terms-of-service';
      }
    });

    if(this.isStorageTimeExpired('startDate') && window.location.href.indexOf('policies/terms-of-service') === -1) {
      this.style.display = 'block';
      document.body.classList.add('body-overflow');
    } else {
        this.style.display = 'none';
        document.body.classList.remove('body-overflow');
    }
  }
}

customElements.define('privacy-modal', PrivacyModal);
